module.exports = __webpack_public_path__ + "img/gateway__poa.1beca45.svg";